import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ShoppingBag, Briefcase, Gift, Diamond, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: ShoppingBag,
    title: "Personal Shopping",
    blurb:
      "Everyday essentials, fashion, electronics, beauty, sportswear — anything from any UK retailer, sourced and shipped.",
    image:
      "https://images.unsplash.com/photo-1483985988355-763728e1935b?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
  {
    icon: Briefcase,
    title: "Business Procurement",
    blurb:
      "B2B sourcing for offices and SMEs. Tech, office equipment, branded merchandise, and consumables from verified UK suppliers.",
    image:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
  {
    icon: Gift,
    title: "Gift Sourcing",
    blurb:
      "Discreet packaging, gift cards, and direct-to-recipient delivery anywhere in Nigeria. Surprises that arrive intact.",
    image:
      "https://images.unsplash.com/photo-1513201099705-a9746e1e201f?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
  {
    icon: Diamond,
    title: "Luxury & Designer",
    blurb:
      "Selfridges, Harrods, Net-a-Porter, Bond Street boutiques. Authenticated, photographed, fully insured.",
    image:
      "https://images.unsplash.com/photo-1584917865442-de89df76afd3?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
  },
];

export default function ServiceCards() {
  return (
    <section
      data-testid="services-section"
      className="bg-[#F8F5F0] py-24 md:py-32 border-t border-[#E5E0D8]"
    >
      <div className="container-mps">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16"
        >
          <div className="max-w-xl">
            <div className="overline text-[#C9A96E] mb-4">Service Tiers</div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight">
              Four ways we shop{" "}
              <span className="italic text-[#C9A96E]">for you</span>.
            </h2>
            <div className="gold-divider mt-8" />
          </div>
          <p className="text-[#6B7280] max-w-md">
            Every order is handled by a real human concierge in London —
            never an automated forwarder, never a marketplace middleman.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#E5E0D8]">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`service-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="bg-[#F8F5F0] p-8 md:p-12 group relative overflow-hidden"
            >
              <div className="aspect-[16/9] overflow-hidden mb-8">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <s.icon className="text-[#C9A96E] mb-5" size={28} strokeWidth={1.4} />
              <h3 className="font-serif text-3xl mb-4">{s.title}</h3>
              <p className="text-[#6B7280] leading-relaxed mb-6">{s.blurb}</p>
              <Link
                to="/services"
                className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] text-[#1A1A1A] hover:text-[#C9A96E] transition-colors"
              >
                Explore <ArrowUpRight size={14} />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
